import { render, staticRenderFns } from "./DangerSign.vue?vue&type=template&id=c07cc978"
import script from "./DangerSign.vue?vue&type=script&lang=js"
export * from "./DangerSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports